// src/app/views/pages_pub/leet/rtPbLeet.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

const LeetLand = Loadable(lazy(() => import("./LeetLand")));
const LeetApply = Loadable(lazy(() => import("./LeetApply")));
const pathExt = getPathByCdExt(EXAM_TYPES.LEET.rid_cd_ext);

const rtPbLeet = [
  { path: `/pub/${pathExt}/land/:rid_cd_ext/:rid_imp_sr`, element: <LeetLand /> },
  { path: `/pub/${pathExt}/apply/:rid_cd_ext/:rid_imp_sr/:gid?`, element: <LeetApply /> },
];
export default rtPbLeet;